export default __webpack_public_path__ + "static/media/filter_image.5b0d11f1.svg";